"use client"

import { useState } from "react"
import "./FAQPage.css"



const FAQPage = () => {
  const faqs = [
    {
      category: "General Questions",
      items: [
        {
          question: "What is Corporate NRIs?",
          answer:
            "Corporate NRIs is a digital platform designed exclusively for NRIs, offering a wide range of services like home rentals, car buying/selling, travel companions, medical support, visa/legal assistance, and more. It connects verified users through a community-driven, post-and-respond model.",
        },
        {
          question: "Who can use Corporate NRIs?",
          answer:
            "The platform is tailored for NRIs, including working professionals, families, students, and retirees living abroad, who need reliable services or want to connect with other NRIs for support.",
        },
        {
          question: "How do I sign up?",
          answer:
            "Visit our website, click 'Sign Up,' and create a profile with your details. All users are verified to ensure a trusted community.",
        },
        {
          question: "Is Corporate NRIs free to use?",
          answer:
            "Basic access to post requests, respond to others, and browse services is free. Some premium features or partnered services may involve fees, which are clearly outlined during transactions.",
        },
      ],
    },
    {
      category: "Using the Platform",
      items: [
        {
          question: "How does the Ask & Answer platform work?",
          answer:
            "1. Post a service request, question, or offer on the platform.\n2. The system routes your post to relevant verified users or service providers.\n3. Receive responses and interact directly to resolve your need.\n4. Provide feedback to maintain quality and trust.",
        },
        {
          question: "How do I find or list a rental property?",
          answer:
            "Navigate to the 'Home Rentals' section, where you can browse verified listings or post your property details. Our corporate-to-corporate verification ensures secure and transparent transactions.",
        },
        {
          question: "Can I buy or sell a car through the platform?",
          answer:
            "Yes! In the 'Car Buying & Selling' section, connect with verified NRI buyers or sellers. Post your car details or browse available vehicles for seamless, fraud-free transactions.",
        },
        {
          question: "How do I access vouchers and deals?",
          answer:
            "Visit the 'Vouchers & Deals' section to explore exclusive discounts on travel, shopping, healthcare, and more. New deals are added regularly, and you can redeem them directly through our partners.",
        },
      ],
    },
    {
      category: "Safety and Verification",
      items: [
        {
          question: "How does Corporate NRIs ensure trust and safety?",
          answer:
            "All users and service providers are verified through a corporate vetting process. We also encourage feedback and ratings to maintain a reliable community. Transactions are monitored to reduce fraud risks.",
        },
        {
          question: "Are my personal details secure?",
          answer:
            "Yes, we prioritize data security with encrypted systems and strict privacy policies. Your information is only shared with relevant users or providers to fulfill your requests.",
        },
      ],
    },
    {
      category: "Specific Services",
      items: [
        {
          question: "How do I find a travel companion?",
          answer:
            "In the 'Travel Companions' section, post your travel plans or browse others' requests. Connect with verified NRIs traveling to similar destinations for safe and supportive journeys.",
        },
        {
          question: "What kind of medical support is available?",
          answer:
            "Our 'Medical Support' service connects you with trusted healthcare advisors, hospitals, and clinics. You can seek remote consultations, second opinions, or local medical recommendations.",
        },
        {
          question: "Can I get help with visa or legal issues?",
          answer:
            "Yes, our 'NRI Visa & Legal Services' section offers access to professionals for visa processing, renewals, and legal guidance. You can also get peer recommendations from the community.",
        },
        {
          question: "How does the commerce and trade marketplace work?",
          answer:
            "In the 'Commerce & Trade' section, buy, sell, or exchange goods like home decor, electronics, or NRI-owned products. All listings are verified to ensure safe transactions.",
        },
      ],
    },
    {
      category: "Feedback and Support",
      items: [
        {
          question: "How do I provide feedback on a service or user?",
          answer:
            "After completing a transaction or interaction, you'll be prompted to rate and review the experience. Your feedback helps maintain our trusted community.",
        },
        {
          question: "What if I encounter an issue with a service or user?",
          answer:
            "Contact our support team via the 'Help' section on the website. We'll investigate and resolve issues promptly to ensure a positive experience.",
        },
        {
          question: "How can I contact Corporate NRIs for further questions?",
          answer:
            "Reach out through our website's 'Contact Us' page or email our support team. We're here to assist you 24/7.",
        },
      ],
    },
  ]

  const [openIndex, setOpenIndex] = useState(null)

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <div className="faq-page">
    
      {/* Main Content */}
      <main className="main-content">
        <h2 className="page-title">Frequently Asked Questions (FAQ)</h2>
        <p className="page-description">
          Find answers to the most common questions about Corporate NRIs, your trusted platform for NRI-focused services
          and community support.
        </p>

        <div className="faq-sections">
          {faqs.map((category, catIndex) => (
            <section key={catIndex} className="faq-section">
              <h3 className="category-title">{category.category}</h3>
              <div className="faq-items">
                {category.items.map((faq, faqIndex) => {
                  const globalIndex = `${catIndex}-${faqIndex}`
                  return (
                    <div key={globalIndex} className="faq-item">
                      <button className="faq-question" onClick={() => toggleFAQ(globalIndex)}>
                        {faq.question}
                        <svg
                          className={`faq-icon ${openIndex === globalIndex ? "rotated" : ""}`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>
                      {openIndex === globalIndex && <p className="faq-answer">{faq.answer}</p>}
                    </div>
                  )
                })}
              </div>
            </section>
          ))}
        </div>

        {/* Call to Action */}
        <section className="cta-section">
          <h3 className="cta-title">Still Have Questions?</h3>
          <p className="cta-description">
            If you don't find the answer you're looking for, post a question on our Ask & Answer platform or contact our
            support team.
          </p>
          <a href="/contact" className="cta-button">
            Contact Us
          </a>
        </section>
      </main>

    
    </div>
  )
}

export default FAQPage
